import { TreeNode, TreeNodeType } from "~/components/build/Show/components/Sidebar/TreeNode";

/** @deprecated Use `~/components/build/Show/routes/list/-components/TreeNode/SpacerItem` instead. */
export function createSpacerNode(id: string): TreeNode {
  return {
    id,
    type: TreeNodeType.Spacer,
    render: () => null,
  };
}
